module.exports = __webpack_public_path__ + "static/media/bars.4cb487a5.svg";